// AUTO-GENERATED FILE - DO NOT EDIT
import * as z from "zod";
import { requestHandler } from "../requestHandler";

export const path = "get-claim-details-files";

export const fileInfoSchema = z
  .object({
    claimDetailId: z.string(),
    name: z.string(),
    // downloadLink: z.string(),
    size: z.number(),
  })
  .strict();

export const getClaimFilesResponseSchema = z.array(fileInfoSchema);

export const getClaimFilesParamsSchema = z
  .object({
    claimDetailIds: z.array(z.string()),
  })
  .strict();




export type FileInfo = z.infer<typeof fileInfoSchema>;

export type GetClaimFilesResponse = z.infer<typeof getClaimFilesResponseSchema>;

export type GetClaimFilesParams = z.infer<typeof getClaimFilesParamsSchema>;




// receiver/get-claim-details-files endpoint
export function getClaimFiles(
  params: z.input<typeof getClaimFilesParamsSchema>
): Promise<GetClaimFilesResponse> {
  return requestHandler(
    "receiver/get-claim-details-files",
    params,
    getClaimFilesResponseSchema,
  );
}

